import { render, staticRenderFns } from "./Movies.vue?vue&type=template&id=2a7fb380"
import script from "./Movies.vue?vue&type=script&lang=js"
export * from "./Movies.vue?vue&type=script&lang=js"
import style0 from "./Movies.vue?vue&type=style&index=0&id=2a7fb380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports